import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { COLORS } from 'consts/colors'
import styled, { css } from 'styled-components'

export const IconWrapperStyles = css`
  z-index: 2;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 32px;
  height: 32px;

  border-radius: 4px;
  border: 1px solid ${COLORS.border};
  background-color: ${COLORS.surface};

  cursor: pointer;

  & > svg {
    fill: ${COLORS.secondarySemiDark};
  }

  @media only screen and (min-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT + 1}px) {
    &:hover {
      border-color: ${COLORS.secondary};
      background-color: ${COLORS.primaryLight};
      & > svg {
        fill: ${COLORS.secondaryDark};
      }
    }
    transition: 0.2s ease-in-out;
  }
`

export const PrimaryActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  & > .iconWrapper {
    ${IconWrapperStyles}
  }
`
